<template>
  <div class="md-layout text-center login-fix-page">
    <div class="md-layout-item md-size-100">
      <div class="text-center">
      </div>
      <div class="text-center" style="margin-bottom: 32px;">
      </div>
    </div>

    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
    >
      <form @submit.prevent="forgetPassword">
        <login-card header-color="green">
          <h4 slot="title" class="title">原來是洋蔥</h4>
          忘記密碼
          <md-field
            class="form-group md-invalid"
            slot="inputs"
            style="margin-bottom: 28px"
          >
            <md-icon>fingerprint</md-icon>
            <label>手機號碼(登入帳號)</label>
            <md-input v-model="mobile" type="text" />
            <validation-error :errors="apiValidationErrors.mobile" />
          </md-field>
          <md-button
            slot="footer"
            class="md-simple md-success md-lg"
            type="submit"
          >
            忘記密碼
          </md-button>
        </login-card>
        <md-button class="md-round" href="/login" >登入</md-button>
        <md-button class="md-round" href="/register" >註冊</md-button><br>
      </form>
    </div>
  </div>
</template>

<script>
import { LoginCard, ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
  components: {
    LoginCard,
    ValidationError,
  },
  mixins: [formMixin],
  computed: {
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated();
    },
  },
  data: () => ({
    mobile: "",
    password: "",
  }),
  methods: {
    notMobile(mobile) {
      return mobile.length != 10
    },
    async forgetPassword() {

      if(this.notMobile(this.mobile)) {
        return this.$store.dispatch("alerts/error", "帳號請輸入手號號碼，長度10");
      }

      const user = {
        data: {
          type: "forget-password",
          attributes: {
            mobile: this.mobile,
          },
        },
      };

      try {
        await this.$store.dispatch("users/fogetPassword", user);
        const [title, message] = (this.$store.getters["users/message"]).split('::');
        if(title == '錯誤') {
          await this.$store.dispatch("alerts/error", message);
        } else {
          await this.$store.dispatch("alerts/success", message);
        }
        

      } catch (e) {
        await this.$store.dispatch("alerts/error", "操作失敗!");
        // this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
<style scoped>
.login-fix-page {
  padding-bottom: 7em;
  padding-top: 4em;
}
</style>
